import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { dateRangeFormFields } from '../constants.ts';

export type DateChipOption = {
  id: string;
  label: string;
  startDate: Date;
  endDate: Date;
};

export type DateRangeChipsProps = {
  options: DateChipOption[];
  disabled?: boolean;
};

export const DateRangeChips = ({ options, disabled = false }: DateRangeChipsProps) => {
  const { setValue } = useFormContext();
  const [showAllOptions, setShowAllOptions] = useState(false);

  const handleClick = (option: DateChipOption) => {
    setValue(dateRangeFormFields.START_DATE, option.startDate, { shouldDirty: true, shouldValidate: true });
    setValue(dateRangeFormFields.END_DATE, option.endDate, { shouldDirty: true, shouldValidate: true });
  };

  const handleToggleOptions = () => {
    setShowAllOptions(!showAllOptions);
  };

  const visibleOptions = showAllOptions ? options : options.slice(0, 4);
  const hasMoreOptions = options.length > 4 && !showAllOptions;

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 1,
        flexWrap: showAllOptions ? 'wrap' : 'nowrap',
        overflow: 'visible',
      }}
    >
      {visibleOptions.map(option => (
        <Chip
          key={option.id}
          label={option.label}
          onClick={() => handleClick(option)}
          sx={{
            cursor: 'pointer',
            margin: 0,
            paddingX: 1.5,
            fontSize: '0.75rem',
            height: '28px',
            flexShrink: 0,
          }}
          disabled={disabled}
        />
      ))}
      {hasMoreOptions && (
        <Button
          onClick={handleToggleOptions}
          sx={{
            minWidth: 'auto',
            paddingX: 1.5,
            paddingY: 0.5,
            fontSize: '0.75rem',
            textTransform: 'none',
            backgroundColor: 'transparent',
            color: 'primary.main',
            height: '28px',
            flexShrink: 0,
            '&:hover': {
              backgroundColor: 'transparent',
              textDecoration: 'underline',
            },
          }}
        >
          +{options.length - 4}
        </Button>
      )}
    </Box>
  );
};
